import { render, staticRenderFns } from "./ProductNotShipped.vue?vue&type=template&id=bdd9efc6&name=product-not-shipped&"
import script from "./ProductNotShipped.vue?vue&type=script&lang=js&"
export * from "./ProductNotShipped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports